import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-43a07527"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-detail"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "common"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "新闻动态")])], -1));
const _hoisted_3 = {
  class: "main"
};
const _hoisted_4 = {
  class: "common center"
};
import useImport from '@/hooks/useImport';
import news from '@/views/home/news';
import news0 from './news0';
import news1 from './news1';
import news2 from './news2';
export default {
  __name: 'news-detail',
  setup(__props) {
    const {
      ref,
      useRoute,
      onMounted
    } = useImport();
    const route = useRoute();
    const id = route.params.id;
    onMounted(async () => {});
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_unref(id) == 0 ? (_openBlock(), _createBlock(_unref(news0), {
        key: 0
      })) : _createCommentVNode("", true), _unref(id) == 1 ? (_openBlock(), _createBlock(_unref(news1), {
        key: 1
      })) : _createCommentVNode("", true), _unref(id) == 2 ? (_openBlock(), _createBlock(_unref(news2), {
        key: 2
      })) : _createCommentVNode("", true)])])]);
    };
  }
};